import {
    LOAD_PARTNER_OBJECTS,
    DATE_CHANGE,
    USER_CHANGE,
    LOAD_MENUS,
    QUANTITY_CHANGE,
    CHANGE_LOCATION,
    MENU_ERROR,
    LOAD_OLD_MENUS,
    CHANGE_DESCRIPTION,
} from '../../modules/food/actions/types';
import {USER_LOGOUT} from '../../modules/auth/actions/types';


const initialState = {
    objects: [],
    date: new Date(),
    currentUser: {
        id: null,
        type: null,
        name: null,
    },
    menus: {},//[type][location] => menu
    saleTimes: [],
    error: [],
    old: [],
    oldDate: "",
    description: ''
};


//[types][locations][wares] => ware
function processMenus(saleTimes) {
    let menus = {}, description = '';
    saleTimes.forEach(saleTime => {
        const type = saleTime.saleTimeId;
        // saleTimes[saleTime.saleTimeId] = saleTime;
        menus[type] = menus[type] || {};
        saleTime.locations.forEach(location => {
            const {locationId, orderDescription} = location;
            menus[type][locationId] = location;
            if (orderDescription) {
                description = orderDescription;
            }
        });
    });

    return {menus, saleTimes, description}
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case LOAD_PARTNER_OBJECTS: {
            return {
                ...state,
                objects: action.payload,
                description: ''
            };
        }
        case USER_CHANGE:
            return {
                ...state,
                currentUser: action.payload,
                description: ''
            };
        case DATE_CHANGE:
            return {
                ...state,
                date: action.date,
                description: ''
            };
        case LOAD_MENUS: {
            return {
                ...state,
                ...processMenus(action.payload),
                error: [],
                old: [],
                oldDate: "",
            };
        }
        case QUANTITY_CHANGE: {
            const {menu_type, location, id, count} = action;
            let menus = JSON.parse(JSON.stringify(state.menus));
            menus[menu_type][location].wares.forEach((ware, k) => {
                if (ware.priceWaresId === id && !ware.isReadOnly) {
                    menus[menu_type][location].wares[k].waresQuantity = count;
                }
            });

            return {
                ...state, menus
            };
        }
        case CHANGE_LOCATION: {
            let saleTimes = JSON.parse(JSON.stringify(state.saleTimes));
            saleTimes.forEach((saleTime, i) => {
                if (saleTime.saleTimeId === action.saleTime) {
                    saleTimes[i].orderLocation = action.newLocation;
                }
            });

            return {
                ...state, saleTimes
            };
        }
        case MENU_ERROR: {
            const {error} = JSON.parse(JSON.stringify(state));
            error.push(action.payload);
            return {
                ...state, error, description: ''
            };
        }
        case LOAD_OLD_MENUS: {
            return {
                ...state, ...action.payload, description: ''
            };
        }
        case USER_LOGOUT: return initialState;
        case CHANGE_DESCRIPTION: return {
            ...state, description: action.description,
        };

        default:
            return state;
    }
};




/** WEBPACK FOOTER **
 ** ./src/redux/reducers/food.js
 **/